export enum READ_DURATION_TYPE {
    ten = 10,
    thirty = 30,
    hour = 60,
}
